import axios from 'axios';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';


function AffichageAncienSelectionCoach(props) {
    const [isLoading,setIsLoading] = useState(false)
    const [error,setError] = useState();
    const { idMatch } = useParams();
    const [joueur,setJoueur] = useState()
    const [pasDispo,setPasDispo] = useState()
    const Navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;





    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${apiUrl}/selection/gestion/coach/${props.userData.user.donnée.results[0].id_equipe}/${idMatch}`,
              {
                withCredentials: true 
              }
            );
            
            setError(null);
            setIsLoading(false);
            setJoueur(response.data);
    
          } catch (error) {
            if (error.response) {
              if (error.response.status === 404) {
                  setPasDispo(error.response.data);
                  
              } else {
                  setError(error.response.data.message);
              }
          } else {
              setError(true);
          }
          setIsLoading(false);
      }
  }
        fetchData(); 
      }, [props, idMatch, apiUrl]);




  return (
    <>
      {pasDispo && (
        <Modal show={pasDispo} onHide={() => Navigate('/coach/tableau-de-bord/selection')}>
          <Modal.Header closeButton>
            <Modal.Title>La sélection n'existe pas</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>La sélection pour le match {pasDispo.match[0].equipe_dom} - {pasDispo.match[0].equipe_ext} n'existe pas</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => Navigate('/coach/tableau-de-bord/selection')} >
              Quitter
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    {joueur && joueur.selection && joueur.match_commentaire && 
      <>
        <Card className="bg-dark text-white" style={{borderRadius: "var(--bs-card-border-radius)"}}>
              <Card.Img src="/img/matchArbitre.jpg" alt="Card image" />
              <Card.ImgOverlay>
                <div className="text-center mb-3">
                  <Card.Title><strong>Sélection du match: {joueur.match[0].equipe_dom} {joueur.match[0].score} {joueur.match[0].equipe_ext}</strong></Card.Title>
                </div>
              </Card.ImgOverlay>
            </Card><br/>
        <CardGroup>
      {joueur.selection.map((joueur, j) => ( 
            <Card key={j}>
              <Card.Body>
                <div className="text-center mb-3">
                  <Card.Title><strong>{joueur.nom} {joueur.prenom}</strong> </Card.Title>
                </div> 
                <Card.Text>
                  <strong>Statut :</strong> {joueur.status} <br/>
                  <strong>Poste :</strong> {joueur.poste !== null ? `${joueur.poste}` : "?"} <br/>
                  <strong>Taille :</strong> {joueur.taile !== null ? `${joueur.taile} m` : "?"} <br/>
                  <strong>Poid :</strong> {joueur.poid !== null ? `${joueur.poid} kg` : "?"} <br/>
                  <strong>Pied fort :</strong> {joueur.pied_fort !== null ? `${joueur.pied_fort}` : "?"} <br/>
                </Card.Text>
              </Card.Body>
              <Card.Footer>
                <Form>
                <Form.Label>Statut</Form.Label>
                  <Form.Select aria-label="Default select example" disabled defaultValue={joueur.status}>
                    <option value="Pas sélectionné" disabled >Pas sélectionné</option>
                    <option value="Sélectionné" disabled>Sélectionné</option>
                    <option value="Blessé" disabled>Blessé</option>
                  </Form.Select>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Commentaire</Form.Label>
                    <Form.Control as="textarea" rows={3} disabled defaultValue={joueur.commentaire} />
                  </Form.Group>
                </Form>
              </Card.Footer>
          </Card>
      ))
      }
      </CardGroup>
     <br/> 
       <Card>
      <Card.Header>Commentaire personnel pour le match {joueur.match[0].equipe_dom} {joueur.match[0].score} {joueur.match[0].equipe_ext}</Card.Header>
      <Card.Body>
      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Commentaire pour toute l'équipe</Form.Label>
                    <Form.Control disabled as="textarea" rows={3} defaultValue={joueur.match_commentaire[0].commentaire} />
                  </Form.Group>
      </Card.Body>
    </Card>
    <br/>
     </> 
  }
    {error && (
        <div id="alert-message" className="alert5" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
    )}
    {isLoading && (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
    )}
  </>
  );
}

export default AffichageAncienSelectionCoach;